import axios from 'axios';
import { URL_ENDPOINT } from '../../../index';
// import { GET_SUPPLIER_INFORMATION } from './types';

export const _getProducts = ( supplierId, page ) => {
    return axios ({
        method: 'get',
        withCredentials: true,
        url:`${URL_ENDPOINT}/api/admin/supplier/products/${supplierId}/${page}`
    })
}


export const _getSupplierInformation = (supplierId) => {
    return axios({
        method:'get',
        withCredentials: true,
        url:`${URL_ENDPOINT}/api/admin/supplier/${supplierId}`
    })
}

export const _postVerificationBoolean = (supplierId, isAccountingInfoVerified, isCompanyInfoVerified) => {
    return axios({
        method: 'post',
        withCredentials: true,
        url:`${URL_ENDPOINT}/api/admin/supplier/verify/${supplierId}`,
        data: { isAccountingInfoVerified, isCompanyInfoVerified }
    })
}




// WEBPACK FOOTER //
// ./src/components/supplier-profile/actions/index.js